<template>
  <div v-show="show.value" id="loading" class="loading">
    <div class="load_box">
      <div id="lottie_loading" ref="animation"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Ref, onMounted, ref } from 'vue'
import lottie from 'lottie-web'
import lottiePraise from '@/assets/loading_plane.json'

defineProps<{
  show: Ref<boolean>
}>()

const animation = ref(null)

onMounted(() => {
  if (animation.value) {
    const lot = lottie.loadAnimation({
      container: animation.value,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: lottiePraise
    })
    // 修改lottie的颜色
    lot.addEventListener('DOMLoaded', () => {
      const svgElement = document.querySelector('#lottie_loading svg')
      if (svgElement) {
        svgElement.querySelectorAll('path').forEach((path) => {
          path.setAttribute('fill', '#EC482F') // 修改为需要的颜色
        })
      }
    })
  }
})
</script>

<style scoped lang="less">
.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
  background: rgba(0, 0, 0, 0.6);

  .load_box {
    background-color: #bbbbbb;
    width: 100px;
    height: 100px;
    border-radius: 8px;
    color: #3c3c3c;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    letter-spacing: 0.8px;
    font-size: 14px;
  }
}
</style>
